import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-faire_academy_negative_feedback_dismiss-click';

/**
 * Click event when dislikes a chapter but chooses to not submit negative faire academy feedback
 */
export function trackOpenWithFaireFaireAcademyNegativeFeedbackDismissClick(
  pageState: string,
  guideName2: string,
  chapterName3: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { pageState, guideName2, chapterName3 },
  });
}
